import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { AddResourceTypeComposer } from "@/forms/rema/addResourceType/composer"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Settings2 } from "lucide-react"
import { useToast } from "@/contexts/ToastContext"

function AddResourceTypePage() {
  const navigate = useNavigate()
  const { toast } = useToast()

  return (
    <div className="p-6 space-y-4">
      <Card className="shadow-sm pb-0">
        <CardHeader className="border-b bg-slate-700 text-white [&_p]:text-slate-300">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <Settings2 className="h-5 w-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-xl">Add Resource Type</CardTitle>
              <CardDescription className="text-base">Define a new resource type with namespace and permissions</CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>
      <Card className="shadow-sm">
        <CardContent className="p-6">
          <AddResourceTypeComposer
            showHeader={false}
            onSuccess={() => navigate({ to: '/rema/resource-types' })}
            onError={(error) => toast({ title: 'Error', description: `Failed to create resource type: ${error.message}`, type: 'error' })}
            onCancel={() => navigate({ to: '/rema/resource-types' })}
          />
        </CardContent>
      </Card>
    </div>
  )
}

export const Route = createFileRoute("/rema/resource-types/add")({
  staticData: {
    title: 'Add Resource Type',
    isSecured: true,
  },
  component: AddResourceTypePage,
})
